import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class TemplateServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params) {
    return this.http.get('select', { params: params });
  }
}

export const TemplateService = new TemplateServiceClass({
  api_version: 2,
  resource: 'message-templates'
});
